import { useContext } from "react";
import { SubscriptionModalContext } from "./SubscriptionModalProvider";

export const useSubscriptionModal = () => useContext(SubscriptionModalContext);
